export default "__VITE_ASSET__Cde6QPUN__"